<template>
  <TableRegular
    :loading="loading"
    :rows="rows"
    :columns="columns"
    :sort="sort"
    :page="page"
    :per-page="perPage"
    :page-size="pageSize"
    :total-page="totalPage"
    :total-records="totalRecords"
    :line-numbers="lineNumbers"
    @onFilter="$emit('onFilter', $event)"
    @onPageChange="$emit('onPageChange', $event)"
    @onPerPageChange="$emit('onPerPageChange', $event)"
    @onSortChange="$emit('onSortChange', $event)"
    class="s"
  >
    <template slot="table-row" slot-scope="props">
      <p v-if="props.column.field === 'transactionDate'" class="whitespace-nowrap">
        {{ props.row.transactionDate }}
      </p>
      <p v-else-if="props.column.field === 'description'" class="leading-4 w-60 text-left">
        {{ props.row.description }}
      </p>
      <p v-else-if="props.column.field === 'amount'" class="text-right">
        {{ props.row.amount | currency }}
      </p>
    </template>
  </TableRegular>
</template>

<script>
import TableRegular from '@/components/ui/table/TableRegular';
import tableMixin from '@/mixins/tableMixin';
import humps from 'humps';

export default {
  mixins: [tableMixin],
  components: {
    TableRegular,
  },
  methods: {
    statusToClassName(status) {
      return status ? status.replace('_', '-').toLowerCase() : '';
    },
    getStatus(status) {
      return status ? humps.camelize(status.toLowerCase()) : '';
    },
  },
};
</script>
